import Styled from 'styled-components';

export default Styled.div`
  font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  visibility: hidden;
  color: ${(props) =>
    props.isPlcc
      ? props.theme.colorPalette.userTheme.plcc
      : props.theme.colorPalette.userTheme.mpr};
  box-sizing: border-box;
  span {
    visibility: visible;
  }
  ${(props) =>
    `font-size: 11px;
    height: 15px;
    @media ${props.theme.mediaQuery.smallMax} {
      font-size:9px;
    }
  `}
  .multiline-ellipsis {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  `;
